module.exports = __webpack_public_path__ + "static/ActivityPub-62eb43c954f6f672e05ca72a07005f9b.png";